<template lang="pug">
	div(v-if="ready && $store.state.takeoverInfo == null")
		sfc-exit-modal
		div(v-b-modal.exit-modal ref="exitModalTrigger" )
		div(v-farewell="onLeave" v-if="$store.state.takeoverInfo == null && readyToTriggerOnExit")
</template>


<style lang="stylus" scoped>
	>>> .full-screen-modal
		.modal-dialog
			.modal-content
				box-shadow: none !important
</style>
<script>
	import Vue from 'vue'
	import { farewellDirectivePlugin } from 'vue-farewell'
	import SfcExitModal from '@/common/components/modals/exit-modal'
	import SfcTrackingService from "@/lib/sfc-tracking-service"

	const options = {
		cookieDomain: 'savingforcollege.com',
		sitewide: true
	}

	Vue.use(farewellDirectivePlugin, options)

	export default {
		data(){
			//let ready = true
			let ready = false
			if(this.$store.state.userIsLoggedIn){
				ready = false
			}

			if(this.$route.path.indexOf("/intro-to-529s/which-is-the-best-529-plan-available") != -1){
				ready = false
			}

			if(this.$route.path.indexOf("/savings-center") != -1){
				ready = false
			}

			return {
				ready,
				readyToTriggerOnExit: false,
				timeToWaitForWelcomeWidget: 15000
			}
		},
		components:{
			SfcExitModal
		},
		mounted(){
			// Disable exit intent on all pages
			this.setRandomBestPlansModalContent()
			this.setReadyToTriggerOnExit()
		},
		methods:{
			setReadyToTriggerOnExit(){
				if(!this.$store.state.userIsLoggedIn){
					setTimeout( () => {
						this.readyToTriggerOnExit = true
					}, this.timeToWaitForWelcomeWidget)
				}
			},
			onLeave () {
				// This is no the best way, but we have no class for those elements
				for(let id = 0; id < 40; id++){
					let element = document.getElementById(`sfc-widget-id-${id}`)
					if(element){
						let style = element.getAttribute("style")
						if(style.indexOf("inline-block") != -1){
							this.trackCollision()
						}
					}
				}
				this.$refs.exitModalTrigger.click()
			},

			trackCollision(){
				SfcTrackingService.trackAnalyticsAction('Exit Intent Modal Collision', 'Show', this.$store.state.bestPlansExitModalContent.version)
			},

			enrollNowUrl(){
				// WATCH OUT ONE LINE IFs

				if(this.$store.state.stateFromIp.id == "DE")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=10&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "GA")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=12&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "HI")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=13&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "ID")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=14&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "IL")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=16&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "IA")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=18&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "ME")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=22&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "MA")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=24&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "MO")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=30&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "NH")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=34&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "NM")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=36&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "NY")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=37&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "NC")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=39&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "ND")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=40&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "OH")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=41&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "RI")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=46&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "VA")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=55&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "SC")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=68&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "DC")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=70&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "MD")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=72&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "AK")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=77&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "CO")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=146&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "IN")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=147&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "AZ")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=148&click_source=exit_intent_modal`

				if(this.$store.state.stateFromIp.id == "NE")
					return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=164&click_source=exit_intent_modal`

			},

			setRandomBestPlansModalContent(){
				// const path = this.$route.path
				// const stateInUrl = path.indexOf(this.$store.state.stateFromIp.slug) != -1
				// const states = ["DE", "GA", "HI", "ID", "IL", "IA", "ME", "MA", "MO", "NH", "NM", "NY", "NC", "ND", "OH", "RI", "VA", "SC", "DC", "MD", "AK", "CO", "IN", "AZ", "NE"]
				// if(states.indexOf(this.$store.state.stateFromIp.id) != -1 && !stateInUrl){
					// content = {
					// 	title: `Looking for a great 529 plan for ${this.$store.state.stateFromIp.name} residents?`,
					// 	copy1: `Click below to get started with this highly rated ${this.$store.state.stateFromIp.name} 529 plan.`,
					// 	exitCopy: "No thanks, I don't want a great 529 plan for my child",
					// 	version: `bestPlanV10 - ${this.$store.state.stateFromIp.name}`,
					// 	secondaryCopy: `Show me more ${this.$store.state.stateFromIp.name} plans`,
					// 	enrollNowUrl: this.enrollNowUrl(),
					// 	statePageUrl: `/529-plans/${this.$store.state.stateFromIp.slug}`,
					// 	firstImageFile: `en-${this.$store.state.stateFromIp.id.toLowerCase()}-takeover-wide.png`,
					// 	exitWithStateImage: true
					// }

				let content

				let randomNumber = Math.ceil(Math.random() * 100)

				if(randomNumber > 200) { // Never true, so go for the else
					content = {
						version: "UpromiseV3",
						firstImageFile: "upromise_exit_intent_v3_optimized_b_no_borders.png",
						firstImageLink: "https://www.upromise.com/s/login/?utm_source=SFC&utm_medium=Display&utm_content=exit_intent_720x480_v3",
						upromiseExitWithText: true
					}
				}else{ // 25% LEAVING OLD CODE JUST IN CASE U NEST RENEWS
					randomNumber = Math.ceil(Math.random() * 100)
					if(randomNumber < 200){ // Always true for email capture
						// Leaving this Email capture for the future
						content = {
							title: "Download a free copy of the 2024-25 Family Guide to College Savings ",
							copy1: "Over 10,000 downloads",
							exitCopy: "No thanks, I don't want a great 529 plan for my child",
							buttonCopy: "Download",
							version: "emailCaptureV1",
							secondaryCopy: "-",
							firstImageFile: "family_guide_2024_2025.png",
							firstImagePlanId: "-",
							secondImageFile: "-",
							secondImagePlanId: "-",
							emailCapture: true
						}

						// content = {
						// 	version: "UNestV1",
						// 	firstImageFile: "u_nest_exit_intent_v1.png",
						// 	firstImageLink: "https://prod.app.u-nest.com/ad-web/?utm_source=SFC&utm_medium=banner&utm_campaign=SFC_january&utm_content=exit_ad_laughing_girls",
						// 	uNestExitWithText: true
						// }

					}else{
						// Leaving Next gen for the future
						// content = {
						// 	title: "Looking for a great 529 plan?",
						// 	copy1: "Click below to get started with this highly rated 529 plan.",
						// 	firstImageFile: "en-merril-takeover-wide.png",
						// 	firstImagePlanId: 22,
						// 	exitCopy: "No thanks, I don't want a great plan for my child",
						// 	exitWithImage: true,
						// 	version: "bestPlanV15"
						// }

						content = {
							version: "UNestV2",
							firstImageFile: "u_nest_exit_intent_v2.png",
							firstImageLink: "https://prod.app.u-nest.com/ad-web/?utm_source=SFC&utm_medium=banner&utm_campaign=SFC_january&utm_content=exit_ad_app_screens",
							uNestExitWithText: true
						}
					}
				}
				this.$store.commit('updateBestPlansExitModalContent', content)
			}
		}



	}
</script>
